$(function () {
	var $mainTaskCard = $('.main-task-card');
	var $studentTaskCard = $('.student-task-card');
	var $assignTaskButton = $('.assign-task-button');

	var businessName = document.querySelector("#business-name");
	var $editBizNav = $('#edit-biz-nav');
	var $addDocNav = $('#add-doc-nav');
	var $shareBizNav = $('#share-biz-nav');
	var $timeClockNav = $('#time-clock-nav');
	var $dangerZoneNav = $('#danger-zone-nav');
	var $editBizContainer = $('#edit-biz-container');
	var $addDocContainer = $('#add-doc-container');
	var $shareBizContainer = $('#share-biz-container');
	var $dangerZoneContainer = $('#danger-zone-container');
	var $timeClockContainer = $('#time-clock-container');

	var $swapBusiness = $(".swap-business");
	var $swapBusinessContainer = $(".swap-business-container");
	var $posProduct = $(".pos-product");
	var $currentOrderContainer = $(".current-order-container");
	var $posCreateOrderButton = $(".pos-create-order-button");
	var $paymentFinalizeOrderButton = $(".payment-finalize");
	var $posCustomerNameInputContainer = $(".customer-name-input");
	var $paymentExitButton = $(".payment-exit");
	var $paymentModalContainer = $(".payment-modal-container");
	var posCustomerInputField = document.querySelector(".pos-input");
	var cashReceivedField =  document.querySelector(".cash-received");
	var $cashReceivedContainer = $(".cash-received-container")
	var paymentDifference = document.querySelector(".payment-difference");
	var $posProduct = $(".pos-product");
	var $removePosProduct = $(".remove-pos-product");
	var $cashPayButton = $(".cash-payment");
	var $creditPayButton = $(".credit-payment");
	var posCurrentOrders = []
	var selectedTasks = []
	var selectedStudents = []
	var $editAuthSub = $("#edit-auth-submit");
	var $editAuthModal = $("#edit-auth-modal");
	var $editAuthError = $("#edit-auth-error");
	var businessDestroyInput = document.querySelector("#business_destroy_target");
	var $businessRemoveDisabled = $("#biz-remove-disabled");
	var $businessRemoveActive =  $("#biz-remove-active");


	var $quickCashContainer = $(".quick-cash-container");
	var $orderNotesContainer = $(".order-notes-container");
	var $orderNotes          = $(".order-notes");



	const cardBlocks = document.querySelectorAll(".cards");

	cardBlocks.forEach((cardBlock) => {

	  cardBlock.style.paddingBottom = `${Math.max(cardBlock.children.length, 1)}em`;

	  Array.from(cardBlock.children).forEach(
	    (card, i) => (card.style.transform = `translateY(${i}em)`)
	  );
	});

	jQuery(document).ready(function($){
	  $('ul.cards').on('click', function(e){
	  	console.log(e.target);
	  	if (e.target.classList.contains('card-link')){
	  		console.log($(this));
	  		console.log("target is a link");
	    	return;
	  	}
	    $(this).toggleClass('transition');
	  });

	  $('ul.cards-split').on('click', function(e){
	  	var $docContainer = $(".doc-container");

	  	console.log(e.target);
	  	if (e.target.classList.contains('card-link')){
	  		console.log($(this));
	  		console.log("target is a link");
	    	return;
	  	}

	    $(this).toggleClass('transition');
	    $docContainer.toggleClass('doc-grow');
	  });
	});


	$swapBusiness.on('click', function () {
		console.log('clicked on swap business');
		if ($swapBusinessContainer.hasClass('hidden')) {
			$swapBusinessContainer.removeClass('hidden');	
		} else {
			$swapBusinessContainer.addClass('hidden');	
		}
		
	})

	// Edit Business Side Nav

	$editBizNav.on('click', function() {
		if ($editBizNav.hasClass('active-side-nav')) {
			return
		} else {
			$editBizNav.addClass('active-side-nav').removeClass('inactive-side-nav');
			$addDocNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$shareBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$dangerZoneNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$timeClockNav.removeClass('active-side-nav').addClass('inactive-side-nav');

			// Show Edit biz
			$editBizContainer.removeClass('lg:hidden');
			$addDocContainer.addClass('lg:hidden');
			$shareBizContainer.addClass('lg:hidden');
			$dangerZoneContainer.addClass('lg:hidden');
			$timeClockContainer.addClass('lg:hidden');
		}
	})

	$addDocNav.on('click', function() {
		if ($addDocNav.hasClass('active-side-nav')) {
			return
		} else {
			$addDocNav.addClass('active-side-nav').removeClass('inactive-side-nav');
			$editBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$shareBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$dangerZoneNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$timeClockNav.removeClass('active-side-nav').addClass('inactive-side-nav');

			// Show add doc
			$addDocContainer.removeClass('lg:hidden');
			$editBizContainer.addClass('lg:hidden');
			$shareBizContainer.addClass('lg:hidden');
			$dangerZoneContainer.addClass('lg:hidden');
			$timeClockContainer.addClass('lg:hidden');
		}
	})

	$shareBizNav.on('click', function() {
		if ($shareBizNav.hasClass('active-side-nav')) {
			return
		} else {
			$shareBizNav.addClass('active-side-nav').removeClass('inactive-side-nav');
			$addDocNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$editBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$dangerZoneNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$timeClockNav.removeClass('active-side-nav').addClass('inactive-side-nav');

			// Show share biz
			$shareBizContainer.removeClass('lg:hidden');
			$addDocContainer.addClass('lg:hidden');
			$editBizContainer.addClass('lg:hidden');
			$dangerZoneContainer.addClass('lg:hidden');
			$timeClockContainer.addClass('lg:hidden');
		}
	})

	$dangerZoneNav.on('click', function() {
		if ($dangerZoneNav.hasClass('active-side-nav')) {
			return
		} else {
			$dangerZoneNav.addClass('active-side-nav').removeClass('inactive-side-nav');
			$addDocNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$editBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$shareBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$timeClockNav.removeClass('active-side-nav').addClass('inactive-side-nav');

			// Show share biz
			$dangerZoneContainer.removeClass('lg:hidden');
			$addDocContainer.addClass('lg:hidden');
			$editBizContainer.addClass('lg:hidden');
			$shareBizContainer.addClass('lg:hidden');
			$timeClockContainer.addClass('lg:hidden');
		}
	})

	$timeClockNav.on('click', function() {
		if ($timeClockNav.hasClass('active-side-nav')) {
			return
		} else {
			$timeClockNav.addClass('active-side-nav').removeClass('inactive-side-nav');
			$addDocNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$editBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$shareBizNav.removeClass('active-side-nav').addClass('inactive-side-nav');
			$dangerZoneNav.removeClass('active-side-nav').addClass('inactive-side-nav');

			// Show share biz
			$timeClockContainer.removeClass('lg:hidden');
			$addDocContainer.addClass('lg:hidden');
			$editBizContainer.addClass('lg:hidden');
			$shareBizContainer.addClass('lg:hidden');
			$dangerZoneContainer.addClass('lg:hidden');
		}
	})

	$editAuthSub.on('click', function() {
		console.log("submit auth sent")
		var pass = document.getElementById("edit_auth_input").value;
		console.log(pass)

		$.ajax({
      url: "/edit_auth",
      type: "post",
      dataType: "json",
      data: {
      	pass: pass,
      },
      // headers: {"X-CSRF-TOKEN": $token},
      success: function(response) {
      	$editAuthModal.addClass('hidden');
      },
      error: function(response) {
      	console.log(response);
      	$editAuthError.removeClass('hidden');
      }
    });

	})

	// Make sure they know which business they are trying to delete by making them type the name of it in before unlocking button
	if(businessDestroyInput) {
		businessDestroyInput.addEventListener("keyup", (event) => {

			if(businessDestroyInput.value == businessName.textContent) {
				// Unlock Delete Confirmation Button
				$businessRemoveDisabled.addClass('hidden');
				$businessRemoveActive.removeClass('hidden');
			} else {
				// Lock Delete Confirmation Button
				$businessRemoveDisabled.removeClass('hidden');
				$businessRemoveActive.addClass('hidden');
			}

		});
	}



	// IF YOU CHECK FOR THE CLICK ON THE ORDER CONTAINER, IT SHOULD PICKUP ELEMENTS THAT ARE ADDED LATER
	$currentOrderContainer.on('click', ".remove-pos-product", function() {
		// find the X button's parent and hide it and update calculations
		console.log($(this).parent().data('product-id'));
		var removeTarget = $(this).parent().data('product-id');

		// filter out all instances of the product id from current orders
		posCurrentOrders = posCurrentOrders.filter((productId) => productId !== removeTarget);

		$(this).parent().remove();
		calculateRunningTotal();

		// if current orders is empty hide create order
		if($.trim($currentOrderContainer.html())=='') {
			$posCustomerNameInputContainer.addClass('hidden');
			$posCreateOrderButton.addClass('hidden');
		  	// Hide & clear notes too
		  	$orderNotesContainer.addClass('hidden');
		  	$orderNotes.val('');
		}
	})
	// END

	// Key up listener for POS customer name to reveal create order if filled and disable if not filled

	if (posCustomerInputField) {
		posCustomerInputField.addEventListener("keyup", (event) => {

			if(posCustomerInputField.value=='') {

				// Disable Create Order Button
				$posCreateOrderButton.addClass('opacity-50 cursor-not-allowed');
				$posCreateOrderButton.removeClass('hover:bg-orange-600 cursor-pointer');
			} else {

				// Enable Create Order Button
				$posCreateOrderButton.removeClass('opacity-50 cursor-not-allowed');
				$posCreateOrderButton.addClass('hover:bg-orange-600 cursor-pointer');
			}
		});
	}

	// Cash Payment Functions 
	if (cashReceivedField) {
		// Key up listener for Cash Payment Entered to format
		// cashReceivedField.addEventListener("keyup", (event) => {
		// 	setTimeout(() => {
		// 		cashReceivedField.value = (Math.round(cashReceivedField.value * 100) / 100).toFixed(2);
		// 	}, 10000)			
		// });

		// Key up listener to check if change is necessary 
		// Recalc on any input, but DO NOT force 2-dec formatting here
		cashReceivedField.addEventListener("input", function () {
		  // Allow empty while typing
		  const v = cashReceivedField.value.trim();
		  if (v === "") {
		    paymentDifference.textContent = "";
		    $paymentFinalizeOrderButton.addClass('button-primary-disabled');
		    $paymentFinalizeOrderButton.removeClass('button-primary');
		    return;
		  }
		  // Recalc using whatever they typed
		  recalcChange();
		});

		// Only format to 2 decimals when they leave the field
		cashReceivedField.addEventListener("blur", function () {
		  const num = parseFloat(cashReceivedField.value);
		  if (isNaN(num)) {
		    cashReceivedField.value = "";
		    paymentDifference.textContent = "";
		    $paymentFinalizeOrderButton.addClass('button-primary-disabled');
		    $paymentFinalizeOrderButton.removeClass('button-primary');
		  } else {
		    cashReceivedField.value = num.toFixed(2);
		    recalcChange();
		  }
		});

	}

	$(document).on('click', '.quick-cash-btn', function() {
	  if (!cashReceivedField) return;

	  var amt = parseFloat($(this).data('amount')) || 0;
	  var current = parseFloat(cashReceivedField.value) || 0;

	  cashReceivedField.value = (current + amt).toFixed(2);
	  recalcChange();
	});


	$posProduct.on('click', function () {
		var productCount = parseInt($(this).data('product-count')) || 0;
		if (productCount <= 0) {
			alert("Item out of stock. Adjust stock to add to order.");
			return;
		}

		var productId = $(this).data('product-id');
		var productName = $(this).data('product-name');
		var productPrice = parseFloat($(this).data('product-price')).toFixed(1);
		var businessId = $(this).data('business-id');

		// console.log(productId);
		console.log(productName);
		console.log(productPrice);
		console.log(businessId);
		// CHECKS TO SEE IF CURRENT ORDER CONTAINER IS EMPTY IF SO ADD PRODUCT
		// ELSE IF CONTENT EXISTS IT CHECKS POS CURRENT ORDERS ARRAY HAS PRODUCT ID ALREADY AND GOES TO INCREMENT
		// ELSE ADDS NEW PRODUCT THAT DOESN'T EXIST IN POS CURRENT ORDERS ARRAY TO LIST AND ADDS TO ARRAY
		if($.trim($currentOrderContainer.html())=='') {
			var newProductForCurrentOrder = `
			<div data-business-id=${businessId} data-product-id="${productId}" data-product-price="${productPrice}" data-product-name='${productName}' data-product-quantity=1 
					class="card-body pos-product text-dark text-center text-white bg-green-500 shadow-md rounded p-2 mb-2">
          <h5 class="card-title text-xl font-bold text-white">${productName}</h5>
          <p class="float-right remove-pos-product text-white cursor-pointer">X</p> 
          <p class="card-text text-white">Retail Price: $${productPrice}0</p>
          <p class="card-text text-white">Order Quantity: <span class="product-${productId}-quantity">1</span></p>
        </div>`
			$currentOrderContainer.append(newProductForCurrentOrder);

			posCurrentOrders.push(productId);
		} else if(posCurrentOrders.includes(productId)) {
			// INCREMENT PRODUCT UP BY ONE FOR PRODUCT CLICKED
			var productQuantity = parseInt($("."+"product-"+$(this).data('product-id')+"-quantity").text());
			var $quantityTarget = $("."+"product-"+$(this).data('product-id')+"-quantity")
			var increasedQuantity = (productQuantity +=1);

			$quantityTarget.text(increasedQuantity);
		} else {
			// ADD NEW PRODUCT
			var newProductForCurrentOrder = `<div data-business-id=${businessId} data-product-id=${productId} data-product-price=${productPrice} data-product-name=${productName} data-product-quantity=1 
			class="card-body pos-product text-dark text-center text-white bg-green-500 shadow-md rounded p-2 mb-2">
          <h5 class="card-title text-xl font-bold text-white">${productName}</h5>
          <p class="float-right remove-pos-product text-white cursor-pointer">X</p> 
          <p class="card-text text-white">Retail Price: $${productPrice}0</p>
          <p class="card-text text-white">Order Quantity: <span class="product-${productId}-quantity">1</span></p>
        </div>`
			$currentOrderContainer.append(newProductForCurrentOrder);

			posCurrentOrders.push(productId);
		}

		// }
		// check for presence END

		$posCustomerNameInputContainer.removeClass('hidden');
		$posCreateOrderButton.removeClass('hidden');
		$orderNotesContainer.removeClass('hidden');
		calculateRunningTotal();
	})

	$posCreateOrderButton.on('click', function() {
		let customerName = $(".pos-input-name").val();

		if ($posCreateOrderButton.hasClass('cursor-not-allowed')) {
			return false
		} else {
			createArrayOfProducts(customerName);
		}
	})

	$paymentFinalizeOrderButton.on('click',function() {
		let customerName = $(".pos-input-name").val();

		if ($paymentFinalizeOrderButton.hasClass('cursor-not-allowed')) {
			return false
		} else {
			finalizeProductOrder(customerName);
		}
	});

	function calculateRunningTotal() {
		// loop through and add up all prices
		// update dom element
	}

	function finalizeProductOrder(customerName) {
	  var thisCustomerName = customerName;
	  var immediateOrder = !!document.querySelector('.immediate-fulfillment') &&
	                       !!document.querySelector('.immediate-fulfillment').checked;

	  var orderProducts = [];

	  $currentOrderContainer.find(".pos-product").each(function () {
	    var $el = $(this);

	    // Read possible data attributes (any of these may or may not exist)
	    var id        = $el.data('product-id');
	    var qtyText   = $("." + "product-" + id + "-quantity").text();
	    var quantity  = parseInt(qtyText, 10) || 0;

	    // Base price (prefer explicit original price if you store it)
	    var originalPrice = parseFloat($el.data('original-price'));
	    if (isNaN(originalPrice)) originalPrice = parseFloat($el.data('product-price'));

	    // If you render a discounted price directly as a data attribute, use it
	    var discountedFromData = parseFloat($el.data('product-discounted-price'));

	    // Or compute from a percent if provided
	    var discountPercent = parseFloat($el.data('discount')) || 0;

	    var finalPrice;
	    if (!isNaN(discountedFromData)) {
	      finalPrice = discountedFromData;
	    } else if (!isNaN(originalPrice) && discountPercent > 0) {
	      finalPrice = +(originalPrice * (1 - discountPercent / 100)).toFixed(2);
	    } else {
	      finalPrice = parseFloat($el.data('product-price'));
	    }

	    var productHash = {
	      product_id: id,
	      product_price: finalPrice,
	      product_quantity: quantity
	      // Optionally include these if your backend wants them:
	      // original_price: originalPrice,
	      // discount_percent: discountPercent
	    };

	    orderProducts.push(productHash);
	  });

	  // Create the order
	  createOrder(orderProducts, thisCustomerName, immediateOrder);
	}

	function createArrayOfProducts(customerName) {
		var thisCustomerName = customerName
		var orderProducts = []
		$currentOrderContainer.find(".pos-product").each(function () {
			// START WITH HASH
			var productHash = {}
			productHash["product_id"] = $(this).data('product-id');
			productHash["product_price"] = $(this).data('product-price');
			productHash["product_quantity"] = parseInt($("."+"product-"+$(this).data('product-id')+"-quantity").text());
			orderProducts.push(productHash);
			// END WITH HASH
			// orderProducts.push($(this).data('product-id'));
		})

		// Calculate amount owed
		calculateTotalOwed(orderProducts, thisCustomerName);

		// This creates an order Need to calculate before
		// createOrder(orderProducts, thisCustomerName);
	}

	$mainTaskCard.on('click', function () {
		if ($(this).hasClass('task-selected')) {
			const index = selectedTasks.indexOf($(this).data('task-id'));
			if (index > -1) { // only splice array when item is found
  			selectedTasks.splice(index, 1); // 2nd parameter means remove one item only
			}
			$(this).removeClass("task-selected");
			$(this).addClass("bg-white");
			$(this).removeClass("bg-green-600");
			$(this).find('h5').removeClass("text-white");
		} else {
			$(this).addClass("task-selected");
			$(this).removeClass("bg-white");
			$(this).addClass("bg-green-600");
			$(this).find('h5').addClass("text-white");
			selectedTasks.push($(this).data('task-id'));	
		}
	})

	$studentTaskCard.on('click', function () {
		if ($(this).hasClass('student-selected')) {
			const index = selectedStudents.indexOf($(this).data('student-id'));
			if (index > -1) { // only splice array when item is found
  			selectedStudents.splice(index, 1); // 2nd parameter means remove one item only
			}
			$(this).removeClass("student-selected");
			$(this).addClass("bg-white");
			$(this).removeClass("bg-yellow-600");
			$(this).find('h5').removeClass("text-white");
		} else {
			$(this).addClass("student-selected");
			$(this).removeClass("bg-white");
			$(this).addClass("bg-yellow-600");
			$(this).find('h5').addClass("text-white");
			selectedStudents.push($(this).data('student-id'));	
		}
	})

	$assignTaskButton.on('click', function () {
		saveTaskAssignments();
	})

	// Activate Cash Pay Option
	$cashPayButton.on('click', function() {
		if ($cashPayButton.hasClass('active-payment-choice')) {
			return
		} else if ($creditPayButton.hasClass('active-payment-choice')){
			$(this).removeClass('payment-method-option').addClass('payment-method-option-selected active-payment-choice');
			$creditPayButton.removeClass('active-payment-choice payment-method-option-selected').addClass('payment-method-option');
			$cashReceivedContainer.removeClass('hidden');
			$quickCashContainer.removeClass('hidden');
			$quickCashContainer.find('.quick-cash-btn').removeClass('quick-cash-selected bg-indigo-50 ring-2 ring-indigo-600').attr('aria-pressed', 'false');
			paymentDifference.innerHTML = "";
			cashReceivedField.value = "0.00";
			$paymentFinalizeOrderButton.addClass('button-primary-disabled');
			$paymentFinalizeOrderButton.removeClass('button-primary');
		} else {
			// Show Cash received input, change style to be selected payment option
			$(this).removeClass('payment-method-option').addClass('payment-method-option-selected active-payment-choice');
			$cashReceivedContainer.removeClass('hidden');
			$quickCashContainer.removeClass('hidden');
			$quickCashContainer.find('.quick-cash-btn').removeClass('quick-cash-selected bg-indigo-50 ring-2 ring-indigo-600').attr('aria-pressed', 'false');
			paymentDifference.innerHTML = "";
			cashReceivedField.value = "0.00";
			$paymentFinalizeOrderButton.addClass('button-primary-disabled');
			$paymentFinalizeOrderButton.removeClass('button-primary');
		}
	})

	// Activate Credit Pay Option
	$creditPayButton.on('click', function() {
		if ($creditPayButton.hasClass('active-payment-choice')) {
			return
		} else if ($cashPayButton.hasClass('active-payment-choice')){
			$(this).removeClass('payment-method-option').addClass('payment-method-option-selected active-payment-choice');
			$cashPayButton.removeClass('active-payment-choice payment-method-option-selected').addClass('payment-method-option');
			$cashReceivedContainer.addClass('hidden');
			$quickCashContainer.addClass('hidden');
			$quickCashContainer.find('.quick-cash-btn').removeClass('quick-cash-selected bg-indigo-50 ring-2 ring-indigo-600').attr('aria-pressed', 'false');
			// Also reset the cash field so it doesn't affect totals
			if (cashReceivedField) cashReceivedField.value = "0.00";
			paymentDifference.classList.remove("payment-error");
			paymentDifference.classList.add("font-bold");
			paymentDifference.innerHTML = "None";
			$paymentFinalizeOrderButton.removeClass('button-primary-disabled');
			$paymentFinalizeOrderButton.addClass('button-primary');
		} else {
			// Show Credit received input, change style to be selected payment option
			$(this).removeClass('payment-method-option').addClass('payment-method-option-selected active-payment-choice');
			$cashReceivedContainer.addClass('hidden');
			$quickCashContainer.addClass('hidden');
			$quickCashContainer.find('.quick-cash-btn').removeClass('quick-cash-selected bg-indigo-50 ring-2 ring-indigo-600').attr('aria-pressed', 'false');
			// Also reset the cash field so it doesn't affect totals
			if (cashReceivedField) cashReceivedField.value = "0.00";
			paymentDifference.classList.remove("payment-error");
			paymentDifference.classList.add("font-bold");
			paymentDifference.innerHTML = "None";
			$paymentFinalizeOrderButton.removeClass('button-primary-disabled');
			$paymentFinalizeOrderButton.addClass('button-primary');
		}
	})

	// Close Payment Screen
	$paymentExitButton.on('click', function() {
		$paymentModalContainer.addClass("hidden");

		// Reset cash received field and change due
		if (cashReceivedField) cashReceivedField.value = "0.00";
		paymentDifference.textContent = "";
		paymentDifference.classList.remove("payment-error", "font-bold");

		// Reset payment method selection
		$cashPayButton.removeClass('active-payment-choice payment-method-option-selected').addClass('payment-method-option');
		$creditPayButton.removeClass('active-payment-choice payment-method-option-selected').addClass('payment-method-option');

		// Hide cash-specific sections
		$cashReceivedContainer.addClass('hidden');
		$quickCashContainer.addClass('hidden');

		// Reset finalize button to disabled
		$paymentFinalizeOrderButton.addClass('button-primary-disabled');
		$paymentFinalizeOrderButton.removeClass('button-primary');
	});

	function recalcChange() {
	  var totalDueStr = document.querySelector(".total-due")?.textContent || "0";
	  var totalAmountDue = parseFloat(totalDueStr) || 0;
	  var received = parseFloat(cashReceivedField.value);

	  if (isNaN(received)) {
	    paymentDifference.textContent = "";
	    $paymentFinalizeOrderButton.addClass('button-primary-disabled');
	    $paymentFinalizeOrderButton.removeClass('button-primary');
	    return;
	  }

	  if (received > totalAmountDue) {
	    var difference = received - totalAmountDue;
	    paymentDifference.classList.remove("payment-error");
	    paymentDifference.classList.add("font-bold");
	    paymentDifference.textContent = "$" + (Math.round(difference * 100) / 100).toFixed(2);
	    $paymentFinalizeOrderButton.removeClass('button-primary-disabled');
	    $paymentFinalizeOrderButton.addClass('button-primary');
	  } else if (received < totalAmountDue) {
	    paymentDifference.classList.remove("font-bold");
	    paymentDifference.classList.add("payment-error");
	    paymentDifference.textContent = "Invalid Payment Amount";
	    $paymentFinalizeOrderButton.addClass('button-primary-disabled');
	    $paymentFinalizeOrderButton.removeClass('button-primary');
	  } else {
	    paymentDifference.classList.remove("payment-error");
	    paymentDifference.classList.add("font-bold");
	    paymentDifference.textContent = "None";
	    $paymentFinalizeOrderButton.removeClass('button-primary-disabled');
	    $paymentFinalizeOrderButton.addClass('button-primary');
	  }
	}

	function urlWithRndQueryParam(url, paramName) {
    const ulrArr = url.split('#');
    const urlQry = ulrArr[0].split('?');
    const usp = new URLSearchParams(urlQry[1] || '');
    usp.set(paramName || '_z', `${Date.now()}`);
    urlQry[1] = usp.toString();
    ulrArr[0] = urlQry.join('?');
    return ulrArr.join('#');
	}

	function handleHardReload(url) {
    window.location.href = urlWithRndQueryParam(url);
    // This is to ensure reload with url's having '#'
    window.location.reload();
	}

	function calculateTotalOwed(orderProducts, customerName) {
		$.ajax({
      url: "/payment",
      type: "post",
      dataType: "json",
      data: {
      	customer_name: customerName,
      	products: orderProducts
      },
      // headers: {"X-CSRF-TOKEN": $token},
      success: function(total) {
        const fixTotal = (Math.round(total * 100) / 100).toFixed(2);
        showPaymentModal(fixTotal);
      },
      error: function(response) {
      }
    });
	}

	function showPaymentModal(total) {
		var $paymentModalContainer = $(".payment-modal-container");
		var $totalDue = $(".total-due");

		$paymentModalContainer.removeClass('hidden');
		$totalDue.text(total)
	}

	function createOrder(productArray, customerName, immediateOrder) {
	  const notesEl = document.querySelector(".order-notes");
	  const notes = notesEl ? notesEl.value : "";

	  $.ajax({
	    url: "/orders",
	    type: "post",
	    dataType: "json",
	    data: {
	      customer_name: customerName,
	      products: productArray,
	      immediate_order: immediateOrder,
	      notes: notes
	    },
	    success: function(response) {
	      window.location.href = window.location.href;
	    },
	    error: function(response) {
	      console.log(response);
	    }
	  });
	}

		// Category -> show only that category's products
	$(document).on('click', '.pos-category', function () {
	  const cat = $(this).data('cat');
	  const $cats = $('.pos-categories-grid');
	  const $prods = $('.pos-products-grid');

	  // Hide category grid, show products grid
	  $cats.addClass('hidden');
	  $prods.removeClass('hidden');

	  // Filter visible product tiles by category
	  $prods.find('.pos-product').each(function () {
	    const thisCat = ($(this).data('category') || '').toString();
	    const isUncat = (thisCat === '' || thisCat === '__uncategorized');
	    const show = (cat === '__all') || (cat === '__uncategorized' && isUncat) || (thisCat === cat);
	    $(this).toggle(show);
	  });
	});

	// Back to Categories
	$(document).on('click', '.pos-category-back', function () {
	  const $cats  = $('.pos-categories-grid');
	  const $prods = $('.pos-products-grid');

	  // Show categories, hide products
	  $prods.addClass('hidden');
	  $cats.removeClass('hidden');

	  // Optional: reset any previously hidden products for a clean slate next time
	  $prods.find('.pos-product').show();
	});

	// ---- Category filters (re-usable) ----
	function wireCategoryFilter(chipSelector, cardSelector, attrName = 'category') {
	  const chips = document.querySelectorAll(chipSelector);
	  if (!chips.length) return;

	  function setActiveChip(target) {
	    chips.forEach(c => c.classList.remove('ring-2', 'ring-blue-500', 'bg-blue-50'));
	    target.classList.add('ring-2', 'ring-blue-500', 'bg-blue-50');
	  }

	  chips.forEach(chip => {
	    chip.addEventListener('click', () => {
	      const cat = chip.dataset.cat;
	      setActiveChip(chip);

	      document.querySelectorAll(cardSelector).forEach(card => {
	        const v = (card.dataset[attrName] || '').toString();
	        const isUncat = (v === '' || v === '__uncategorized');
	        const show = (cat === '__all') || (cat === '__uncategorized' && isUncat) || v === cat;

	        // Hide/show the *outer* tile wrapper if present
	        const outer = card.closest('[class*="p-4"]') || card; 
	        outer.style.display = show ? '' : 'none';
	      });
	    });
	  });

	  // Default to "All"
	  const all = Array.from(chips).find(c => c.dataset.cat === '__all');
	  all && all.click();
	}

	// POS sell page tiles:
	wireCategoryFilter('.pos-cat-chip', '.pos-product');

	// Inventory tab tiles:
	wireCategoryFilter('.inv-cat-chip', '.inventory-tab-container [data-category]');

	// Supply tab tiles:
	wireCategoryFilter('.sup-cat-chip', '.supply-tab-container [data-category]');

	// ----- INVENTORY: category -> products -----
	$(document).on('click', '.inv-category-card', function () {
	  const selected = $(this).data('category');
	  const $cats  = $('.inv-categories-grid');
	  const $prods = $('.inv-products-grid');

	  // Show only matching products
	  $prods.find('.inv-product-card').each(function () {
	    const cat = $(this).data('category');
	    $(this).toggle(cat === selected);
	  });

	  $cats.addClass('hidden');
	  $prods.removeClass('hidden');
	});

	// Back to categories (inventory)
	$(document).on('click', '.inv-category-back', function () {
	  const $cats  = $('.inv-categories-grid');
	  const $prods = $('.inv-products-grid');

	  // Reset products (show all for future filtering)
	  $prods.find('.inv-product-card').show();

	  $prods.addClass('hidden');
	  $cats.removeClass('hidden');
	});

	// ----- SUPPLIES: category -> products -----
	$(document).on('click', '.sup-category-card', function () {
	  const selected = $(this).data('category');
	  const $cats  = $('.sup-categories-grid');
	  const $prods = $('.sup-products-grid');

	  $prods.find('.sup-product-card').each(function () {
	    const cat = $(this).data('category');
	    $(this).toggle(cat === selected);
	  });

	  $cats.addClass('hidden');
	  $prods.removeClass('hidden');
	});

	// Back to categories (supplies)
	$(document).on('click', '.sup-category-back', function () {
	  const $cats  = $('.sup-categories-grid');
	  const $prods = $('.sup-products-grid');

	  $prods.find('.sup-product-card').show();

	  $prods.addClass('hidden');
	  $cats.removeClass('hidden');
	});

	function saveTaskAssignments() {
		$.ajax({
      url: "/assign_main_tasks",
      type: "post",
      dataType: "json",
      data: {
        selected_main_tasks: selectedTasks,
        selected_students: selectedStudents
      },
      // headers: {"X-CSRF-TOKEN": $token},
      success: function(response) {
      },
      error: function(response) {
        console.log(response);
      }
    });
    window.location.reload(true);
	}
})

